import { FLOWS, FLOW_VALUES } from './reservation-flow.constants';
import * as i0 from "@angular/core";
export class ReservationFlowService {
    constructor() { }
    setFlow(flowValue) {
        this.flow = flowValue && FLOW_VALUES[flowValue];
    }
    getFlow() {
        return this.flow;
    }
    isModFlow() {
        return !!this.flow;
    }
    isModSailingFlow() {
        return this.flow && this.flow.id === FLOWS.sailing;
    }
}
ReservationFlowService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ReservationFlowService_Factory() { return new ReservationFlowService(); }, token: ReservationFlowService, providedIn: "root" });
